import { TripBookingReminder } from '../../lib/types/models/trip-booking/trip-booking-reminder'
import { TripBookingReminderInput } from '../../lib/types/models/trip-booking/trip-booking-reminder-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripBookingReminder(
  input: TripBookingReminderInput & { id: number; tripBookingId: number }
) {
  const { id, tripBookingId, ...data } = input
  return restApiClient
    .url(
      constructApiUrl(API['trip-bookings'].updateReminder.url, {
        id: tripBookingId,
        reminderId: id
      })
    )
    .patch<TripBookingReminder, TripBookingReminderInput>(data)
}
